export default __webpack_public_path__ + "static/media/5.b6eee575.svg";